import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function Checkbox(props) {
  const { t } = useTranslation();
  const {
    name,
    label,
    isChecked,
    handleChange,
    isInline = true,
    disabled = false,
    labelAlignment = "left",
  } = props;
  const inputId = `checkbox-${name.toLowerCase().replace(/\s+/g, "-")}`;

  return (
    <Form.Group>
      <Form.Label htmlFor={inputId}>
        <Form.Check
          className="form-checkbox"
          type="checkbox"
          inline={isInline}
        >
          <span>{labelAlignment === "left" && t(label)}</span>
          <div
            className={`checkbox-container ${isChecked ? "checked" : ""} ${
              disabled ? "disabled" : ""
            }`}
          >
            <Form.Check.Input
              type="checkbox"
              name={name}
              id={inputId}
              checked={isChecked}
              onChange={(e) => handleChange(e.target.checked)}
              disabled={disabled}
            />
          </div>
          {labelAlignment === "right" && t(label)}
        </Form.Check>
      </Form.Label>
    </Form.Group>
  );
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  isInline: PropTypes.bool,
  disabled: PropTypes.bool,
  labelAlignment: PropTypes.string,
};

Checkbox.defaultProps = {
  isInline: true,
  disabled: false,
  labelAlignment: "left",
};

export default Checkbox;
